import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useRef, useState } from 'react'
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import ShowBookingData from './showBookingData'
import Lockers from './lockers'
import { primary_color } from '../../../../Helper/uiHelper'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../../../Redux/Reducers/notificationHandling'
import { ACADEMIC_YEAR_DROPDOWN, BLOCK_DROPDOWN, MAINTAINANCE_TYPE_DROPDOWN, OFFSALE, PUT_PREVIOUS_LOCKER_MAINTAINANCE } from '../../../../Utils/paymentUtils'
import RoundedSelect from '../../../Form/Fields/roundedSelect'
import { fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'
import PublicToggle from '../../../Form/Fields/toggle'
import { EDIT_MOVE_CONTEXT_KEY } from '../editPurchase'
import SchoolPenSelect from '../schoolPenSelect'

const parseMoney = (value) => {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return value
  const cleaned = String(value).replace(/[^0-9.-]/g, '')
  const n = parseFloat(cleaned)
  return Number.isFinite(n) ? n : null
}

const LockerMove = ({
  item,
  unitData,
  fetchBookingData = () => {},
  domainId,
  setChangeLocker,
  isPupilPremium,
  onChangeLockerInPupilPremium = () => {},
  redirectToEdit = () => {},
}) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  let parent_row_id = currentRow?.[currentRow?.length - 1]?.uuid
  const paymentAmount = parseMoney(currentRow?.[0]?.amount)

  const [oldData, setOldData] = useState(item)
  const [newData, setNewData] = useState(item)
  const [confirmationMail, setConfirmationMail] = useState(false)
  const [isMoving, setIsMoving] = useState(false)
  const isMovingRef = useRef(false)
  const schoolLabel = currentRow?.[0]?.domain_id_label || currentRow?.[0]?.domain_name || ''
  const [selectedSchoolId, setSelectedSchoolId] = useState(domainId)
  const [selectedSchoolName, setSelectedSchoolName] = useState(schoolLabel)
  const [schoolLogo, setSchoolLogo] = useState('')
  const [formData, setFormData] = useState([{ ...item, domain_id: domainId, domain_id_label: schoolLabel }])
  const [maintainanceForm, setMaintainanceForm] = useState([{}])
  const [isWarning, setIsWarning] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!selectedSchoolId) return
    request('retrieve-data-by-table', 'POST', {
      source_table: 'domains',
      row_id: selectedSchoolId,
    }).then((res) => {
      const school = res?.data?.data
      if (!school) return
      if (school.domain_name) setSelectedSchoolName(school.domain_name)
      setSchoolLogo(school.logo ? process.env.REACT_APP_STORAGE + school.logo : '')
    })
  }, [selectedSchoolId])

  const onCancelBooking = () => {
    if (isPupilPremium) {
      setChangeLocker(null)
    } else {
      setNewData(oldData)
    }
  }

  useEffect(() => {
    setOldData(item)
  }, [JSON.stringify(item)])
  useEffect(() => {
    const nextSchool = formData?.[0]?.domain_id
    if (!nextSchool || String(nextSchool) === String(selectedSchoolId)) return
    setSelectedSchoolId(nextSchool)
    setSelectedSchoolName(formData?.[0]?.domain_id_label || '')
    setFormData((prev) =>
      (prev || []).map((row, i) => {
        if (i !== 0) return row
        return {
          ...row,
          item_date_time_id: null,
          item_date_time_id_label: '',
          category_id: null,
          category_id_label: '',
          location_id: null,
          location_id_label: '',
        }
      })
    )
    setNewData((old) => ({
      ...old,
      domain_id: nextSchool,
      domain_id_label: formData?.[0]?.domain_id_label,
      item_id: null,
      item_id_label: '',
      location_id: null,
      location_id_label: '',
    }))
  }, [formData?.[0]?.domain_id])
  useEffect(() => {
    if (formData?.[0]?.location_id && formData?.[0]?.location_id !== oldData?.location_id) {
      setNewData({
        ...newData,
        location_id: formData?.[0]?.location_id,
        location_id_label: formData?.[0]?.location_id_label,
      })
    }
  }, [formData?.[0]?.location_id])

  const onValidateBooking = () => {
    const newCost = parseMoney(newData?.total_cost)
    const oldCost = parseMoney(oldData?.total_cost)
    // Prefer amount already paid on the purchase; fall back to old locker cost.
    const paidOrOld = paymentAmount !== null ? paymentAmount : oldCost
    if (newCost === null || paidOrOld === null) {
      return true
    }
    // Charge only when new discounted locker cost exceeds amount already paid.
    return !(newCost > paidOrOld)
  }

  const storeEditMoveContext = () => {
    const paymentId = currentRow?.[0]?.id
    const payload = {
      payment_id: paymentId,
      item_date_time_id: formData?.[0]?.item_date_time_id || newData?.item_date_time_id,
      item_date_time_id_label: formData?.[0]?.item_date_time_id_label || newData?.item_date_time_id_label,
      location_id: formData?.[0]?.location_id || newData?.location_id,
      location_id_label: formData?.[0]?.location_id_label || newData?.location_id_label,
      category_id: newData?.category_id || oldData?.category_id,
      category_id_label: newData?.category_id_label || oldData?.category_id_label,
      item_id: newData?.item_id,
      item_id_label: newData?.item_id_label,
      total_cost: newData?.total_cost,
    }
    try {
      sessionStorage.setItem(EDIT_MOVE_CONTEXT_KEY, JSON.stringify(payload))
    } catch (e) {
      // ignore
    }
  }

  const onMoveBooking = () => {
    // Block double-submit: first request succeeds, retry hits Lost source unit → false error toast.
    if (isMovingRef.current) return
    isMovingRef.current = true
    setIsMoving(true)
    const newBookingPayload = {
      ...newData,
      item_date_time_id: formData?.[0]?.item_date_time_id || newData?.item_date_time_id,
      item_date_time_id_label: formData?.[0]?.item_date_time_id_label || newData?.item_date_time_id_label,
      location_id: formData?.[0]?.location_id || newData?.location_id,
      location_id_label: formData?.[0]?.location_id_label || newData?.location_id_label,
    }
    request('move-booking', 'POST', {
      old_booking: oldData,
      new_booking: newBookingPayload,
      send_confirmation_mail: confirmationMail,
      parent_row_id,
      maintaince: maintainanceForm?.[0],
    })
      .then((res) => {
        if ((res?.status === 200 || res?.status === 202) && res?.data?.success !== false) {
          dispatch(setNotification({ type: 'success', message: 'Booking moved successfully!' }))
          fetchBookingData()
        } else {
          dispatch(setNotification({ type: 'error', message: res?.data?.message || 'Something went wrong!' }))
          isMovingRef.current = false
          setIsMoving(false)
        }
        dispatch(fetchUpdateApiData())
      })
      .catch(() => {
        dispatch(setNotification({ type: 'error', message: 'Something went wrong!' }))
        dispatch(fetchUpdateApiData())
        isMovingRef.current = false
        setIsMoving(false)
      })
  }

  const onChangeQuestion = (i, val) => {
    let oldQuestions = newData?.questions
    let newQuestions = oldQuestions?.map((que, index) => {
      if (index === i) {
        return {
          ...que,
          answer: val,
        }
      } else {
        return que
      }
    })
    setNewData((old) => {
      return {
        ...old,
        questions: newQuestions,
      }
    })
  }
  return (
    <div className='my-4'>
      <AvForm>
        <Row>
          {!isPupilPremium &&
            newData?.questions?.map((question, i) => {
              return (
                <Col md={6} key={question?.uuid || i}>
                  <AvField
                    type='text'
                    name={question?.uuid}
                    label={question?.question}
                    onChange={(e) => onChangeQuestion(i, e.target.value)}
                    value={question?.answer}></AvField>
                </Col>
              )
            })}
        </Row>
      </AvForm>
      <div className='mb-5'>
        <ShowBookingData item={oldData}></ShowBookingData>
      </div>
      <hr></hr>
      <AvForm>
        <PublicToggle
          data={PUT_PREVIOUS_LOCKER_MAINTAINANCE}
          setFormData={setMaintainanceForm}
          formFieldValue={maintainanceForm?.[0]}
          formIndex={0}
          parentData={{ id: domainId }}
          isMoveBooking={true}></PublicToggle>
        <PublicToggle
          data={OFFSALE}
          setFormData={setMaintainanceForm}
          formFieldValue={maintainanceForm?.[0]}
          formIndex={0}
          isMoveBooking={true}
          parentData={{ id: domainId }}></PublicToggle>
        <RoundedSelect
          data={MAINTAINANCE_TYPE_DROPDOWN}
          setFormData={setMaintainanceForm}
          formFieldValue={maintainanceForm?.[0]}
          formIndex={0}
          parentData={{ id: domainId }}></RoundedSelect>
      </AvForm>
      <hr></hr>
      <SchoolPenSelect
        schoolId={selectedSchoolId}
        schoolName={selectedSchoolName}
        logo={schoolLogo}
        onChange={(school) => {
          setFormData((prev) =>
            (prev || []).map((row, i) => {
              if (i !== 0) return row
              return {
                ...row,
                domain_id: school.id,
                domain_id_label: school.name,
              }
            })
          )
        }}
      />
      <AvForm>
        <RoundedSelect
          key={`year-${selectedSchoolId || ''}`}
          data={ACADEMIC_YEAR_DROPDOWN}
          setFormData={setFormData}
          formFieldValue={formData?.[0]}
          formIndex={0}
          parentData={{ id: selectedSchoolId }}
        />
        <RoundedSelect
          key={`block-${selectedSchoolId || ''}`}
          data={BLOCK_DROPDOWN}
          setFormData={setFormData}
          formFieldValue={formData?.[0]}
          formIndex={0}
          parentData={{ id: selectedSchoolId }}
          depend_field_source_table='categories'
        />
      </AvForm>

      <Lockers
        dependent_value={formData?.[0]?.location_id}
        unitData={unitData}
        currentLockerData={oldData}
        newLockerData={newData}
        formData={formData}
        setFormData={setFormData}
        setNewData={setNewData}
        paymentId={currentRow?.[0]?.id}></Lockers>
      <div className='ml-2'>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <input
            checked={confirmationMail}
            type='checkbox'
            id='emailCheckBox'
            className='subtitle1'
            onChange={(e) => {
              setConfirmationMail(e.target.checked)
            }}
          />
          <label for='emailCheckBox' className='font-weight-bold mt-2 subtitle1' style={{ opacity: 0.7 }}>
            Send Code
          </label>
        </div>
      </div>
      <div className='my-5 d-flex justify-content-end'>
        <button
          className='btn rounded-pill mt-2 text-danger border-danger mr-3'
          type='button'
          id='close-btn'
          onClick={() => {
            onCancelBooking()
          }}
          style={{ fontWeight: 700, width: '8rem' }}>
          Cancel
        </button>
        <button
          className='btn text-white rounded-pill mt-2'
          type='button'
          disabled={isMoving}
          onClick={(e) => {
            if (isMovingRef.current) return
            if (isPupilPremium) {
              onChangeLockerInPupilPremium(newData)
            } else {
              if (onValidateBooking()) {
                onMoveBooking()
              } else {
                setIsWarning(true)
              }
            }
          }}
          style={{
            background: primary_color,
            fontWeight: 700,
            width: '8rem',
            opacity: isMoving ? 0.7 : 1,
            cursor: isMoving ? 'not-allowed' : 'pointer',
          }}>
          {isMoving ? 'Saving...' : 'Save'}
        </button>
      </div>

      <Modal
        isOpen={isWarning}
        centered={true}
        toggle={() => {
          setIsWarning(false)
        }}
        style={{ width: '50rem', boxShadow: 'none', maxWidth: '50rem' }}>
        <ModalHeader style={{ backgroundColor: '#FFF', border: 'none', padding: '2rem' }}>
          <div className='p font-weight-bold' style={{ color: primary_color }}>
            This booking move has resulted in a charge. If you like to continue to move this booking please go to the admin interface for move
            booking.
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-between'>
            <button
              className='btn rounded-pill mt-2 text-danger border-danger mr-3'
              type='button'
              onClick={() => {
                setIsWarning(false)
              }}
              style={{ fontWeight: 700, width: '48%' }}>
              Cancel
            </button>
            <button
              className='btn text-white rounded-pill mt-2 mr-3'
              type='button'
              onClick={() => {
                setIsWarning(false)
                storeEditMoveContext()
                redirectToEdit()
              }}
              style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
              Edit & Move
            </button>

            <button
              className='btn text-white rounded-pill mt-2 '
              type='button'
              disabled={isMoving}
              onClick={() => {
                if (isMovingRef.current) return
                setIsWarning(false)
                onMoveBooking()
              }}
              style={{
                background: primary_color,
                fontWeight: 700,
                width: '48%',
                opacity: isMoving ? 0.7 : 1,
                cursor: isMoving ? 'not-allowed' : 'pointer',
              }}>
              {isMoving ? 'Saving...' : 'Move without charge'}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default LockerMove
